module.exports = __webpack_public_path__ + "static/media/jose victor salcedo ccama.a577190b.jpg";